import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronRight,
  faClose,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';
import {
  useGetQuestionAnswerResponseMutation,
} from '../../../../../../features/authentication/reportApiSlice';
import Modal from '../../../../../../components/Modal';
import html2pdf from 'html2pdf.js';
import { colorCode } from '../StudentSessionReport/components/constants';
import QuestionPreviewModal from '../../../../components/QuestionPreviewModal';
import { selectFerpaState } from '../../../../../../features/authentication/authSlice';
import { useSelector } from 'react-redux';
import CustomToast from '../../../../../../components/Toast';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const IndividualQuestionTable = ({
  details,
  sessionReportOptions,
  showRetryOptions,
  includesRetakeData,
  singleStudent,
  displayRetakeVersion,
  retryScoringOptionId
}) => {
  const [expand, setExpand] = React.useState(true);
  const [showQuestionPreviewModal, setShowQuestionPreviewModal] = React.useState(false);
  const [answerModalOpen, setAnswerModalOpen] = React.useState(false);
  const [getQuestionAnswerResponse] = useGetQuestionAnswerResponseMutation();
  const [questionAnwserResponse, setQuestionAnwserResponse] = React.useState(null);
  const [selectedAnswer, setSelectedAnswer] = React.useState(null);
  const [questionNumber, setQuestionNumber] = React.useState(0);
  const [assignmentId, setAssignmentId] = React.useState();
  const [questionId, setQuestionId] = React.useState();
  const ferpaEnabled = useSelector(selectFerpaState);

  const headers = [
    { headerText: 'Name', showHeader: !singleStudent },
    { headerText: 'Student ID', showHeader: !singleStudent },
    { headerText: 'Assignment Version', showHeader: singleStudent },
    { headerText: 'Score', showHeader: true },
  ];

  const handleQuestionPrviewPrint = async () => {
    const options = {
      margin: 60,
      filename: 'your-pdf-file.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }
    };

    const contentWrapper = document.getElementById('content');
    const contentClone = contentWrapper.cloneNode(true);

    const h3Tag = document.createElement('h3');
    h3Tag.textContent = 'Student Reponse to question #' + questionNumber;
    h3Tag.style.fontSize = '1.125rem';
    h3Tag.style.lineHeight = '26px';
    h3Tag.style.fontWeight = '500';

    h3Tag.style.marginBottom = '15px';
    h3Tag.style.paddingBottom = '15px';

    h3Tag.style.borderBottom = '2px solid #e7edff';
    contentClone.insertBefore(h3Tag, contentClone.firstChild);
    await html2pdf().set(options).from(contentClone).save('StudentResponse.pdf');
  };

  const questionDetailsModalHandler = async (questionId, assignmentId) => {
    setAssignmentId(assignmentId);
    setQuestionId(questionId);
    setShowQuestionPreviewModal(!showQuestionPreviewModal);
  };

  const answerModalHandler = async (result, sessionId, questionNumber) => {
    if (sessionId == -1 || result.questionId == 0) {
      return;
    }
    const options = {
      questionId: result.questionId,
      sessionId: sessionId,
      courseId: result.courseId
    };
    setQuestionNumber(questionNumber);
    try {
      const response = await getQuestionAnswerResponse(options).unwrap();
      setAnswerModalOpen(!answerModalOpen);
      setQuestionAnwserResponse(response);
    } catch (error) {
      CustomToast(error.data, 'error');
      setAnswerModalOpen(false);
      console.log(error);
    }
    setSelectedAnswer(result);
  };

  return (
    <div className="mt-5">
      <div className="d-flex justify-content-between">
        <p className="table_tittle">
          Individual Question Results
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip className="custom-tooltip">
                Click the status indicator for specific student answers.
              </Tooltip>
            }>
            <FontAwesomeIcon icon={faQuestionCircle} />
          </OverlayTrigger>
        </p>

        <button
          style={{
            background: '#e1eeff',
            color: 'rgba(84, 113, 200, 0.6)',
            width: '30px',
            height: '30px',
            textAlign: 'center',
            border: 'none',
            marginLeft: '10px'
          }}
          className="rounded-circle"
          onClick={() => setExpand(!expand)}>
          {expand ? (
            <FontAwesomeIcon icon={faChevronDown} />
          ) : (
            <FontAwesomeIcon icon={faChevronRight} />
          )}
        </button>
      </div>
      {expand && (
        <>
          <div className={`table-container ${singleStudent ? 'singleStudentIndividualQuestionTable' : 'individualQuestionTable'}`}>
            <table id="individualQuestion" className={'w-100'}>
              <tr className="table-head">
                {headers &&
                <>
                  {headers?.filter(h => h.showHeader).map((item, index) => (
                    <th key={`individualQuestionHeader${index}`}>{item.headerText}</th>
                  ))}
                </>
                }
                {details?.studentResults
                  .filter((x) => x.assignmentStarted == true)[0]
                  ?.results.map((result, index) => (
                    <th
                      key={index}
                      onClick={() =>
                        questionDetailsModalHandler(
                          result?.questionId,
                          details?.assignmentId
                        )
                      }>
                      <span
                        style={{
                          borderBottom: '1px solid #000000',
                          cursor: 'pointer'
                        }}>
                        Q{index + 1}
                      </span>
                    </th>
                  ))}

                {includesRetakeData == true && !singleStudent && <th style={{ width: '8%', textWrap: 'nowrap' }}># Of Retakes</th>}
              </tr>
              {details?.studentResults.map((item, index) => {
                if (!item.assignmentStarted && !sessionReportOptions.displayNotStartedStudents) return null;

                if (includesRetakeData == true && !singleStudent) {
                  if (displayRetakeVersion == 'original' && !item.originalAssignment) return null;
                  if (displayRetakeVersion == 'bestScore' && !item.bestScore) return null;
                }
                return (
                  <tr key={index} className="tabel-body">
                    {!singleStudent && <>
                      <td>{!ferpaEnabled ? 'name hidden' : item.name}</td>
                      <td>{!ferpaEnabled ? 'identification hidden' : item.identification}</td>
                    </>}
                    {singleStudent &&
                      <td>
                        {item.versionNumber == 0 ? 'Original' : `Retake ${item.versionNumber}`}
                      </td>}

                    <td>{typeof item.score === 'number' ? Math.round(item.score) : item.score}</td>
                    {item?.results.map((result, index) => {
                      if (result.crStatus) {
                        if (
                          result.crStatus.score == 127 &&
                          item.assignmentStarted &&
                          sessionReportOptions?.scoreUnscoredCRZero
                        ) {
                          return (
                            <td
                              key={index}
                              className={`text-center ${result.overridden && 'overriden'}`}>
                              <div
                                onClick={() =>
                                  answerModalHandler(result, item.sessionId, index + 1)
                                }
                                className="indication mx-auto"
                                title="Answered (0 points out of 1 maximum points)">
                                {'[0]'}
                              </div>
                            </td>
                          );
                        } else if (
                          item.assignmentCompleted == false &&
                          item.assignmentStarted &&
                          result.crStatus.status !== 'Answered' &&
                          sessionReportOptions?.scoreStartedNotCompletedIncorrect
                        ) {
                          return (
                            <td
                              key={index}
                              className={`text-center ${result.overridden && 'overriden'}`}>
                              <div
                                onClick={() =>
                                  answerModalHandler(result, item.sessionId, index + 1)
                                }
                                style={{
                                  '--background': '#FFE3E3',
                                  '--iconColor': '#F84646',
                                  cursor: 'pointer'
                                }}
                                className="indication mx-auto">
                                <FontAwesomeIcon icon={faClose} />
                                <span className="visually-hidden">X</span>
                              </div>
                            </td>
                          );
                        } else if (
                          result.crStatus.status == 'Answered' &&
                          result.crStatus.score == 127
                        ) {
                          return (
                            <td
                              key={index}
                              className={`text-center ${result.overridden && 'overriden'}`}>
                              <div
                                onClick={() =>
                                  answerModalHandler(result, item.sessionId, index + 1)
                                }
                                style={{
                                  '--background': '#9694FF',
                                  cursor: 'pointer'
                                }}
                                className="indication mx-auto"
                                title={`Answered (not scored yet,maximum points are ${result.crStatus.maxPoints})`}>
                                <span className="visually-hidden">Answered</span>
                              </div>
                            </td>
                          );
                        } else if (
                          result.crStatus.status === 'Answered' &&
                          result.crStatus.score !== 127
                        ) {
                          return (
                            <td
                              key={index}
                              className={`text-center ${result.overridden && 'overriden'}`}>
                              <div
                                onClick={() =>
                                  answerModalHandler(result, item.sessionId, index + 1)
                                }
                                className="indication mx-auto"
                                style={{ cursor: 'pointer' }}
                                title={`Answered (${result.crStatus.score} points out of ${result.crStatus.maxPoints} maximum points)`}>
                                {`[${result.crStatus.score}]`}{' '}
                              </div>
                            </td>
                          );
                        } else if (result.crStatus.status == 'In Progress') {
                          return (
                            <td
                              key={index}
                              className={`text-center ${result.overridden && 'overriden'}`}>
                              <div
                                onClick={() => answerModalHandler(result, item.sessionId)}
                                style={{
                                  '--background': '#FC6EFF',
                                  cursor: 'pointer'
                                }}
                                className="indication mx-auto"
                                title={'In Progress'}>
                                <span className="visually-hidden">In Progress</span>
                              </div>
                            </td>
                          );
                        } else if (result.crStatus.status == 'Correct on previous try') {
                          return (
                            <td
                              key={index}
                              className={`text-center ${result.overridden && 'overriden'}`}>
                              <div
                                style={{ color: '#959595', cursor: 'default' }}
                                className="indication mx-auto"
                                title={`Answered on previous try (${result.crStatus.score} points out of ${result.crStatus.maxPoints} maximum points)`}>
                                {`[${result.crStatus.score}]`}{' '}
                              </div>
                            </td>
                          );
                        } else {
                          return (
                            <td
                              key={index}
                              className={`text-center ${result.overridden && 'overriden'}`}>
                              <div
                                title="Not Answered"
                                style={{
                                  '--background': '#FFFFFF',
                                  '--border': '1px solid #000000 ',
                                  cursor: 'pointer'
                                }}
                                className="indication mx-auto">
                                <span className="visually-hidden">Not Answered</span>
                              </div>
                            </td>
                          );
                        }
                      } else if (
                        (sessionReportOptions?.scoreStartedNotCompletedIncorrect &&
                          result.status == 'Not Answered') ||
                        (sessionReportOptions?.scoreNotStarted && result.status == null)
                      ) {
                        return (
                          <td
                            key={index}
                            className={`text-center ${result.overridden && 'overriden'}`}>
                            <div
                              className="indication mx-auto"
                              style={{
                                '--background': '#FFE3E3',
                                '--iconColor': '#F84646',
                                cursor: 'pointer'
                              }}>
                              <FontAwesomeIcon icon={faClose} />
                              <span className="visually-hidden">Incorrect</span>
                            </div>
                          </td>
                        );
                      } else {
                        const color = colorCode.find((code) => code?.status === result.status);
                        if (!color) return (
                          <td><div className="indication mx-auto"></div></td>
                        );
                        return (
                          <td
                            key={index}
                            className={`text-center ${result.overridden && 'overriden'}`}>
                            {sessionReportOptions?.scoreStartedNotCompletedIncorrect == false &&
                              result.status == 'Not Answered' ? null : (
                                <div
                                  onClick={() => color.clickActionEnabled ?
                                    answerModalHandler(result, item.sessionId, index + 1) : undefined
                                  }
                                  className="indication mx-auto"
                                  style={{
                                    '--background': color?.backgroundColor,
                                    '--iconColor': color?.iconColor,
                                    '--border': color?.border,
                                    cursor: color.clickActionEnabled ? 'pointer' : 'default'
                                  }}>
                                  {color?.icon ||
                                  color?.icons?.map((item, index) => (
                                    <>
                                      {' '}
                                      {item.icon2}
                                      {item.icon1}
                                    </>
                                  ))}
                                  <span className="visually-hidden">{color?.hiddenValue}</span>
                                </div>
                              )}
                          </td>
                        );
                      }
                    })}
                    {includesRetakeData && !singleStudent && <td>{item.numberOfRetakes}</td>}
                  </tr>
                );
              })}
            </table>
          </div>
          <div
            style={{
              border: '1px solid #d6d6d6',
              borderRadius: '15px',
              padding: '15px'
            }}
            className="d-flex flex-wrap justify-content-between mt-3">
            {colorCode.map((item, index) => {

              // Hide retries icon if requested
              if (!showRetryOptions && item.id == 3) return;
              if (!includesRetakeData && item.id == 8) return;

              // If retries are shown adjust text according to scoring
              if (item.id == 3) {
                switch (retryScoringOptionId) {
                case 1:
                  item.name = 'Correct on Retry (counted as no-credit in the scoring)';
                  break;
                case 2:
                  item.name = 'Correct on Retry (counted as half-credit in the scoring)';
                  break;
                case 3:
                  item.name = 'Correct on Retry (counted as full-credit in the scoring)';
                  break;
                }
              }

              return (


                <div key={index} className="col-lg-4">
                  <div className="d-flex gap-3 ">
                    <div
                      className="indication"
                      style={{
                        '--background': item?.backgroundColor,
                        '--iconColor': item?.iconColor,
                        '--border': item?.border
                      }}>
                      {item?.icon}
                      {item?.icons &&
                        item?.icons.map((item) => (
                          <>
                            {item.icon2}
                            {item.icon1}
                          </>
                        ))}
                    </div>
                    <p key={index}>{item?.name}</p>
                  </div>
                </div>
              );
            }
            )}
          </div>
        </>
      )}

      <QuestionPreviewModal
        isOpen={showQuestionPreviewModal}
        onClose={() => setShowQuestionPreviewModal(false)}
        questionId={questionId}
        assignmentId={parseInt(assignmentId)}
        isPublicAssignment={false}
      />

      <Modal
        titleName={'Student Reponse to question #' + questionNumber}
        isOpen={answerModalOpen}
        contentWidth={'35%'}
        onClose={() => setAnswerModalOpen(false)}>
        <div id="content">
          {selectedAnswer?.status === 'Correct' && (
            <table>
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div dangerouslySetInnerHTML={{ __html: questionAnwserResponse?.status }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Correct Answer</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.correctAnswer || ' '
                      }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Question Id</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.questionId
                      }}></div>
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          {selectedAnswer?.status === 'Incorrect' && (
            <table>
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div dangerouslySetInnerHTML={{ __html: questionAnwserResponse?.status }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Correct Answer</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.correctAnswer
                      }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Question Id</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.questionId
                      }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Student Response</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.studentAnswer
                      }}></div>
                  </td>
                </tr>
                {showRetryOptions &&
                  <tr>
                    <td>Student Retry Response</td>
                    <td>
                      <span className="px-5">:</span>
                    </td>
                    <td>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: questionAnwserResponse?.studentRetryResponse
                        }}></div>
                    </td>
                  </tr>
                }

              </tbody>
            </table>
          )}

          {selectedAnswer?.crStatus?.status === 'Answered' && (
            <table>
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div dangerouslySetInnerHTML={{ __html: questionAnwserResponse?.status }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Sample Answer</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.sampleAnswer
                      }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Student Answer</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.studentAnswer
                      }}></div>
                  </td>
                </tr>
              </tbody>
            </table>
          )}
          {selectedAnswer?.crStatus?.status === 'Not Answered' && (
            <table>
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div dangerouslySetInnerHTML={{ __html: questionAnwserResponse?.status }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Sample Answer</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.sampleAnswer
                      }}></div>
                  </td>
                </tr>
              </tbody>
            </table>
          )}

          {selectedAnswer?.status === 'Correct on Retry' && (
            <table>
              <tbody>
                <tr>
                  <td>Status</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div dangerouslySetInnerHTML={{ __html: questionAnwserResponse?.status }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Correct Answer</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.correctAnswer
                      }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Question Id</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.questionId
                      }}></div>
                  </td>
                </tr>
                <tr>
                  <td>Student Response</td>
                  <td>
                    <span className="px-5">:</span>
                  </td>
                  <td>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: questionAnwserResponse?.studentAnswer
                      }}></div>
                  </td>
                </tr>
                {showRetryOptions &&
                  <tr>
                    <td>Student Retry Response</td>
                    <td>
                      <span className="px-5">:</span>
                    </td>
                    <td>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: questionAnwserResponse?.studentRetryResponse
                        }}></div>
                    </td>
                  </tr>
                }

              </tbody>
            </table>
          )}
        </div>
        <div className="d-flex justify-content-center mt-4">
          <button
            id="printButton"
            style={{ minWidth: '100px' }}
            onClick={handleQuestionPrviewPrint}
            width="100px"
            className="btn btn-castleRed">
            Print
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default IndividualQuestionTable;
